import { useParams } from "react-router";
import DocumentForm from "./DocumentForm";

export default function NewEmployeeDocument() {
  const { id } = useParams();
  return (
    <DocumentForm ownerType="EMPLOYEE" ownerId={id} returnPath={`/employees/${id}?tab=documents`} />
  );
}
